import { NavigateFunction, Location } from "react-router-dom";

export const history = {
  navigate: null as unknown as NavigateFunction,
  location: null as unknown as Location,
};
